import { useEffect, useState } from 'react';

const TOKEN_KEY = 'authToken';

export function useAuth() {
  const [token, setTokenState] = useState<string | null>(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState<any | null>(null);
  const setToken = (t: string | null) => { setTokenState(t); if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); };
  const logout = () => { setToken(null); setUser(null); };
  useEffect(() => { (window as any).__auth = { token, setToken, user, setUser, logout }; }, [token, user]);
  return { token, setToken, user, setUser, logout };
}

export function useAuthBridge() { return (window as any).__auth as ReturnType<typeof useAuth> | undefined; }
